/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://jdz4tb46dnf3hngliiahgsmxfa.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-gqambozyqjfvtagor6heqd2xcy",
    "aws_cognito_identity_pool_id": "us-east-2:aacb0517-0fee-4df8-962d-beef2c28bc7c",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_7eAAsBWWY",
    "aws_user_pools_web_client_id": "1u5nb1hrbaa2jhklu24f4qfnua",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
